import axios from 'axios'
import AuthToken from '@/auth/auth-token'
import { paginate } from './paginate'

class Phone {
  constructor () {
    const phone = axios.create({
      baseURL: process.env.VUE_APP_BASE_API,
      withCredentials: false,
      headers: {
        'Content-type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept'
      }
    })

    this.phone = phone
  }

  async post (data) {
    await AuthToken.setAuth(this.phone)

    return this.phone({
      url: 'v1/party_phone',
      method: 'POST',
      data: data
    })
  }

  async get (id) {
    await AuthToken.setAuth(this.phone)

    return this.phone({
      url: `v1/party_phone/${id}`,
      method: 'GET'
    })
  }

  async getList (id, limit, offset, paging = true) {
    await AuthToken.setAuth(this.phone)

    if (paging) {
      const url = `v1/party_phone/${id}`
      return paginate(this.phone, url, limit, offset)
    }
    return this.phone({
      url: `v1/party_phone/${id}/${limit}/${offset}`,
      method: 'GET'
    })
  }

  async put (id, data) {
    await AuthToken.setAuth(this.phone)

    return this.phone({
      url: `v1/party_phone/${id}`,
      method: 'PUT',
      data: data
    })
  }
}

export default new Phone()
